import React, { useEffect, useState } from "react";
import Footer from "../../../components/shared/Footer";
import ServiceContacts from "./ServiceContacts";
import Attorney from "./Attorney";
import Users from "./Users";
import PaymentMethod from "./PaymentMethod";
import { TylerAdminService } from "../../../services/ClientService";
import { Firm } from "../../../models/swagger/generated-client-service";
export default function TylerFirmsPage() {
    const [firm, setFirm] = useState<Firm>({} as Firm);

    useEffect(() => {
        document.title = "My Firm";
        TylerAdminService.getMyFirm().then((res: any) => {
            if (res && res.data && res.successful) {
                setFirm(res.data);
            } else {
                console.log(res.errorMessage);
            }
        });
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title"> Your Firm </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Your Firm
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <Users />
                <Attorney />
                <ServiceContacts />
                <PaymentMethod />
            </div>
            <Footer />
        </div>
    );
}
